import Glide, {
  Controls,
  Breakpoints,
  Autoplay,
  Swipe,
} from '@glidejs/glide/dist/glide.modular.esm'

class ScGlide extends HTMLElement {
  constructor() {
    super();
    this.settings = {
      type: 'carousel',
      perView: 5,
      peek: 0,
      startAt: 0,
      bound: false,
      gap: 0,
      breakpoints: {
        750: {
          perView: 1,
          autoplay: 5000,
          gap: 20
        }
      },
    }

    if (this.querySelector('[glide-settings]') !== null) {
      this.settings = JSON.parse(
        this.querySelector('[glide-settings]').textContent
      )
    }

    this.carousel = new Glide(this, this.settings)
      .on('mount.after', () => {
        const images = [...this.querySelectorAll('.lazyload')]
        images.map((image) => {
          if (image.classList.contains('lazyload')) {
            const width = image.parentNode.offsetWidth
            image.src = image.dataset.src.replace('{width}', width)
          }
        })
      })
      .mount({ Controls, Breakpoints, Autoplay, Swipe })

      if (window.innerWidth > 750 && this.dataset.desktop == 'false') {
        this.carousel.destroy();
      }
  }
}
customElements.define('sc-glide', ScGlide)
